import { render, staticRenderFns } from "./OrdersHistoryContainer.vue?vue&type=template&id=700a94d6&"
import script from "./OrdersHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./OrdersHistoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrdersHistoryContainer.vue"
export default component.exports